import { HilabsStyled as styled } from '@hilabs-react-ui-components/utils'
import {
  HilabsGrid as Grid,
  HilabsBox as Box,
  HilabsCard as Card,
  HilabsButton as Button,
} from '@hilabs-react-ui-components/core'

export const StyledGridComponent = styled(Grid)(() => ({
  height: '100vh',
}))

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.divider,
  position: 'relative',
  zIndex: 0,
  overflow: 'hidden',
}))

export const StyledBoxImage = styled(Box)(() => ({
  position: 'absolute',
  bottom: -50,
  zIndex: -9,
}))

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
}))

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'uppercase',
  height: theme.spacing(5.5),
  borderRadius: theme.spacing(0.5),
}))
